/**
 * Where "Contact support" writes to. The same address the Feed's pending
 * analysis banner already uses.
 */
export const SUPPORT_EMAIL = 'support@hoopers.club';
